import Component from '@glimmer/component';

import Pickr from '@simonwep/pickr/dist/pickr.es5.min';

import '@simonwep/pickr/dist/themes/classic.min.css';

import { modifier } from 'ember-modifier';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class UiFormFieldColor extends Component {
  // Defaults
  pickr = null;

  // Getter and setter
  get format() {
    return this.args.format ?? 'hex';
  }

  // Functions
  setColor = (color) => {
    let value;

    if (!color) {
      value = null;
    } else if (this.format === 'rgba') {
      // The 0 is the rounding precision, e.g. full numbers rgba(26, 179, 148, 1)
      value = color.toRGBA().toString(0);
    } else {
      value = color.toHEXA().toString();
    }
    this.pickr.hide();
    this.args.onChange(value);
  };

  setupPickr = modifier((element) => {
    const el = element.appendChild(document.createElement('div'));

    const pickr = Pickr.create({
      components: {
        hue: true,
        interaction: {
          clear: true,
          cmyk: true,
          hex: true,
          hsla: true,
          hsva: false,
          input: true,
          rgba: true,
          save: true,
        },
        opacity: this.format === 'rgba',
        preview: true,
      },
      default: this.args.value ?? null,
      defaultRepresentation: this.format,
      disabled: this.args.isDisabled,
      el,
    });

    pickr.on('save', this.setColor);
    pickr.on('show', (_, pickr) => {
      if (!this.args.value) {
        pickr.setColor('#1AB394', true);
      }
    });

    this.pickr = pickr;

    return () => pickr.destroyAndRemove();
  });

  // Template
  <template>
    <div class={{(bem)}} ...attributes>
      <div class={{bem 'picker'}} {{this.setupPickr}}></div>

      <div class={{bem 'value'}}>
        {{@value}}
      </div>
    </div>
  </template>
}
